export default "__VITE_ASSET__7Kfd$A0l__"